module.exports = __webpack_public_path__ + "static/media/logo_audifyz_copy.b957f666.png";